import { SelectList, SelectListEvent } from '@acies/core';
import { IPositions } from '../../../domain/positions';
import { ConfiguratorModel } from '../configurator.model';
import PositionItemRenderer from './position-item-renderer/position-item-renderer';
import PositionsListEvent from './positions-list-event';

export default class PositionsList extends SelectList<IPositions> {
	public constructor() {
		super();
		// The arrow keys move the selection rather than a focus ring over it, so a position is
		// priced and drawn as the user walks the list. It also makes the list one tab stop, at the
		// selected row: tabbing through every position to reach the one that is selected would
		// leave the arrow keys with nothing to do. See SelectList.autoSelectWhenFocused.
		this.autoSelectWhenFocused = true;
		this.width = 'fill';
		this.height = 'fill';
		this.paddingHorizontal = 0;
		this.paddingVertical = 0;
		// the scrollbar is there from the first row rather than appearing at the one that overflows,
		// so the rows never shift under the header, which is aligned to it once
		this.alwaysShowVerticalScrollbar = true;
		this.data = ConfiguratorModel.positions;
		this.ItemRenderer = PositionItemRenderer;
	}

	protected override initialize(): void {
		super.initialize();
		this.#addEventListeners();
	}

	/**
	 * The SelectListEvent is caught here rather than left to bubble, so the list is the only place that speaks about list items.
	 *
	 * The listener needs no binding: `this` is the currentTarget, which is this list.
	 */
	#addEventListeners(): void {
		this.addEventListener(SelectListEvent.SELECTION_CHANGED, this.#selectionChanged as EventListener);
	}

	/**
	 * Answers the SelectList selection with a PositionsListEvent.
	 *
	 * The SelectList raises this both when a position is selected and when it is de-selected, and the selectedItem is null in the latter case, so the one path covers both.
	 */
	#selectionChanged(event: SelectListEvent<IPositions | null>): void {
		event.stopPropagation();
		this.dispatchEvent(new PositionsListEvent(event.selectedItem));
	}
}
customElements.define('cf-positions-list', PositionsList);
